import React from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import {
  determineIfMagazine,
  determineMagazineIssueMonth,
  determineMagazineIssueNumber,
  containsTag
} from '../../../../utils/tag_category_util';
import MagazineAttribution from '../../magazine_attribution/magazine_attribution';
import Author from './author';
import PersonalizedRecommendations from '../../personalized_recommendations/personalized_recommendations';
import featureFlags from '../../../../../feature_flags';
import NewsletterWidget from '../../NewsletterWidget/NewsletterWidget';

const Footer = props => {
  const {
    post,
    isLongPost,
    hasNewsletter,
    bylineAttribution,
    config,
    promoText,
    hasFCEB,
    canRenderInfiniteScroll,
    isFirstPost
  } = props;
  const { tags, categories, author, link, customFields } = post;
  const isMagazine = determineIfMagazine(categories);
  const hasAuthor = isLongPost && !bylineAttribution;
  const isAdvertorial = containsTag(tags, 'advertorial');
  const { guestAuthors } = customFields;

  const hasPersonalizedRecommendations =
    featureFlags.postPersonalizedRecommendationsEnabled &&
    !containsTag(tags, 'advertorial');

  const abGroupCookie = Cookies.get('abgroup');
  let defaultABGroup = 0;
  let showRecommendations = false;
  if (abGroupCookie) {
    defaultABGroup = parseInt(abGroupCookie, 10);
  }

  if (defaultABGroup === 1 || defaultABGroup === 2) {
    showRecommendations = true;
  }

  if (!isMagazine && !hasAuthor && !hasNewsletter) {
    return null;
  }

  return (
    <footer className="post__footer">
      {isMagazine ? (
        <MagazineAttribution
          issueMonth={determineMagazineIssueMonth(tags)}
          issueNumber={determineMagazineIssueNumber(tags)}
          config={config}
        />
      ) : (
        ''
      )}
      {!isAdvertorial &&
        isFirstPost && (
          <div className="post__footer__newsletter">
            <NewsletterWidget articleFooter />
          </div>
        )}
      {hasAuthor &&
        !guestAuthors && (
          <Author modifier="post" {...author} hasFCEB={hasFCEB} />
        )}
      {promoText && (
        <div
          className="globalPostFooter"
          dangerouslySetInnerHTML={{ __html: promoText }}
        />
      )}
      {hasPersonalizedRecommendations &&
      showRecommendations &&
      canRenderInfiniteScroll ? (
        <PersonalizedRecommendations
          post={post}
          config={config}
          link={link}
          isAdvertorial={containsTag(tags, 'advertorial')}
        />
      ) : (
        ''
      )}
    </footer>
  );
};

Footer.defaultProps = {
  promoText: '',
  hasFCEB: false,
  canRenderInfiniteScroll: false,
  isFirstPost: true
};

Footer.propTypes = {
  post: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    author: PropTypes.shape({}).isRequired
  }).isRequired,
  config: PropTypes.shape({}).isRequired,
  bylineAttribution: PropTypes.string.isRequired,
  isLongPost: PropTypes.bool.isRequired,
  hasNewsletter: PropTypes.bool.isRequired,
  promoText: PropTypes.string,
  hasFCEB: PropTypes.bool,
  canRenderInfiniteScroll: PropTypes.bool,
  isFirstPost: PropTypes.bool
};

export default Footer;
